<template>
  <div class="card">
    <v-container grid-list-md>
      <v-layout
        row
        wrap
      >
        <v-flex
          v-for="tvShow in items.tvShows"
          :key="tvShow.id"
          class="card__flex"
          xs6
          sm4
          md4
          lg3
        >
          <v-card
            flat
            class="card__item elevation-5"
            :class="margin"
            color="white"
          >
            <v-card-actions
              v-if="checklogin"
              class="pa-0"
            >
              <v-spacer />

              <v-btn
                v-if="!isBookmark && !isFavor(tvShow.id)"
                slot="activator"
                flat
                icon
                color="blue-grey lighten-1"
                @click="addToFavor(tvShow)"
              >
                <v-icon>bookmark</v-icon>
              </v-btn>

              <v-btn
                v-else-if="!isBookmark && isFavor(tvShow.id)"
                slot="activator"
                flat
                icon
                color="blue-grey lighten-1"
                @click="deleteFromFavor(getIndex(tvShow.id), tvShow.name, $event)"
              >
                <v-icon color="amber accent-4">
                  bookmark
                </v-icon>
              </v-btn>

              <v-btn
                v-else-if="isBookmark"
                slot="activator"
                flat
                icon
                color="blue-grey lighten-1"
                @click="deleteFromFavor(tvShow.fbId, tvShow.name, $event)"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-actions>

            <router-link
              class="card__link"
              :to="'/serie/' + tvShow.id"
            >
              <div class="card__picture">
                <v-lazy-image
                  :src="tvShow.poster_path ? `${imgPrefix}${tvShow.poster_path}` : noPosterSrc"
                  :src-placeholder="gradient"
                />
              </div>
            </router-link>

            <router-link
              class="card__link"
              :to="'/serie/' + tvShow.id"
            >
              <v-card-text class="card__details pa-2">
                <h2 class="body-2 main--text text-no-wrap text-truncate ma-0">
                  {{ tvShow.name }}
                </h2>
              </v-card-text>
            </router-link>

            <section class="card__bottom">
              <p class="card__year caption main--text ma-0 ml-2">
                {{ parseDate(tvShow.first_air_date) }}
              </p>

              <div
                class="card__rating"
                :class="paintRate(tvShow.vote_average)"
              >
                {{ parseRate(tvShow.vote_average) }}%
              </div>
            </section>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>


<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-unresolved
import { base } from '@/config/config';

const noPosterSrc = require('../../assets/noposter.jpg');
const gradient = require('../../assets/gradient.jpg');

export default {
  props: {
    items: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imgPrefix: base.imgPrefix,
      noPosterSrc,
      gradient,
      showContent: null,
    };
  },
  computed: {
    ...mapState({
      getFavList(state) {
        return state.favors.favors.tvShows;
      },
    }),
    isBookmark() {
      return this.$route.name === 'bookmarks';
    },
    checklogin() {
      return this.$store.getters.login;
    },

    margin() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'mx-0 mb-3';
        case 'sm':
          return 'mx-1 mb-3';
        case 'md':
          return 'mx-2 mb-3';
        case 'lg':
          return 'mx-3 mb-4';
        case 'xl':
          return 'mx-3 mb-4';
        default:
          return 'mx-3 mb-4';
      }
    },
  },
  methods: {
    addToFavor(tvShow) {
      // eslint-disable-next-line no-param-reassign
      tvShow.type = 'tvShow';
      this.$store.dispatch('addToFavorList', tvShow);
    },
    deleteFromFavor(id, title, event) {
      const card = event.target.closest('.card__item');

      if (!this.isBookmark) {
        const index = this.getFavList[id].fbId;
        this.$store.dispatch('deleteFromFavorList', { id: index, title });
      } else {
        const getAction = () => {
          card.parentElement.remove();
          this.$store.dispatch('deleteFromFavorList', { id, title });
        };

        card.style.transform = 'scale(0)';
        card.style.opacity = '0';
        setTimeout(() => {
          getAction();
        }, 400);
      }
    },
    isFavor(id) {
      // return false;
      return this.getFavList.findIndex(el => el.id === id) !== -1;
    },
    getIndex(id) {
      return this.getFavList.findIndex(el => el.id === id);
    },
    parseDate(date) {
      return new Date(date).toLocaleDateString();
    },
    parseRate(rate) {
      if (!rate) {
        return 0;
      }
      return Math.round(rate * 10);
    },
    paintRate(raiting) {
      let color;
      if (raiting === 0) color = 'card__rating--no';
      if (raiting >= 1 && raiting < 5) color = 'card__rating--low';
      if (raiting >= 5 && raiting < 7) color = 'card__rating--mid';
      if (raiting >= 7) color = 'card__rating--high';
      return color;
    },
  },

};
</script>

<style lang="scss" scoped>
.v-lazy-image {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  filter: blur(10px);
  transition: filter 0.7s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}

.card {
  &__flex {
    position: relative;
    transition: transform 0.25s ease-in-out;

    &:hover {
      @media (min-width: 959px) {
        transform: translateY(-10px);
        // transform: scale(1.02);
      }
    }
  }

  &__item {
    transition: all 0.4s ease-in-out;
  }

  &__link {
    text-decoration: none;
  }

  &__picture {
    position: relative;
    padding-bottom: 145%;
    overflow: hidden;
  }

  &__progress {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }

  &__genere {
    margin: 0;
    margin-top: auto;
  }

  &__bottom {
    display: flex;
    align-items: center;
    border-top: 1px solid #ccc;
  }

  &__rating {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 43px;
    height: 43px;
    text-align: center;
    color: #fff;

    &--no {
      background-color: #bdbdbd;
    }

    &--low {
      background-color: #d84315;
    }

    &--mid {
      background-color: #ffa726;
    }

    &--high {
      background-color: #43a047;
    }
  }
}
</style>
